<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{$t("setting.fill_bank_tip")}}</div>
      <van-cell-group>
        <van-field v-model="bank" :label="bankFieldLabels.bank" :placeholder="bankFieldPlaceholders.bank" />
        <van-field v-model="branchName" :label="bankFieldLabels.branchName" :placeholder="bankFieldPlaceholders.branchName" />
        <van-field v-model="branchNo" :label="bankFieldLabels.branchNo" type="digit" :placeholder="bankFieldPlaceholders.branchNo" />
        <van-field v-model="bankid" :label="bankFieldLabels.accountNo" type="digit" :placeholder="bankFieldPlaceholders.accountNo" />
        <van-field v-model="username" :label="bankFieldLabels.accountName" :placeholder="bankFieldPlaceholders.accountName" />
      </van-cell-group>
      <p>{{$t("setting.bank_warn")}}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{$t("setting.bank_ok")}}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{},
      is_bind:false,
      bankid:"",
      username:"",
      mobile:"",
      bank:"",
      branchName:"",
      branchNo:"",
      bank_code:"",
      opw: '',
      tpw: '',
      bankFieldLabels: {
        bank: '銀行名',
        branchName: '支店名',
        branchNo: '支店番号',
        accountNo: '口座番号',
        accountName: '口座名義'
      },
      bankFieldPlaceholders: {
        bank: '銀行名を入力してください',
        branchName: '支店名を入力してください',
        branchNo: '支店番号を入力してください',
        accountNo: '口座番号を入力してください',
        accountName: '口座名義を入力してください'
      }
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
      if(this.bank === "" || this.bank === null || this.bank === undefined){
        this.$toast.fail(this.bankFieldPlaceholders.bank);
        return false;
      }
      if(this.branchName === "" || this.branchName === null || this.branchName === undefined){
        this.$toast.fail(this.bankFieldPlaceholders.branchName);
        return false;
      }
      if(this.branchNo === "" || this.branchNo === null || this.branchNo === undefined){
        this.$toast.fail(this.bankFieldPlaceholders.branchNo);
        return false;
      }
      if(this.bankid === "" || this.bankid === null || this.bankid === undefined){
        this.$toast.fail(this.bankFieldPlaceholders.accountNo);
        return false;
      }
      if(this.is_bind){
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if(this.username===""){
        this.$toast(this.bankFieldPlaceholders.accountName);
        return false;
      }
    
      this.$http({
        method: 'post',
        data:{
          bankid:this.bankid,
          bank:this.bank,
          branch_name:this.branchName,
          branch_no:this.branchNo,
          bank_code: this.bank_code,
          username:this.username,
          mobile:this.mobile,
          opw:this.opw,
          tpw:this.tpw
        },
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bank = res.data.info.bankinfo || '';
            this.branchName = res.data.info.branch_name || '';
            this.branchNo = res.data.info.branch_no || '';
            this.bankid = res.data.info.bankid || '';
            this.username = res.data.info.username || '';
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox{
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box{
  background: #fff;

}
.main-box .label{
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#988fba,#f487e0);
}
</style>
